import { render, staticRenderFns } from "./Readers.vue?vue&type=template&id=1d6f7e38&"
import script from "./Readers.vue?vue&type=script&lang=ts&"
export * from "./Readers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports